<template>
  <div class="open-api-config-editor">
    <div v-rect-loading="loading" class="editor-body">
      <TableList
        class="response-config"
        row-key="_vid"
        :title="openApi && $t(`${i18nPrefix}.openApiType.${openApi.type}`)"
        :drag-el-class="dragBtnClass"
        :list-data="configInfoList"
        :table-columns="tableColumns"
        :span-method="spanMethod"
        :show-create-btn="false"
      >
        <template #responseKey="{ row }">
          <div v-if="row.isAddBtnLine" class="add-btn-wrapper">
            <el-button class="add-btn" @click="onAddClick">{{ $t('common.btn.add') }}</el-button>
          </div>
          <el-input v-else v-model="row.responseKey"></el-input>
        </template>
        <template #dataKey="{ row }">
          <el-select v-model="row.dataKey">
            <el-option
              v-for="(dataKeyInfo) in dataKeyInfoList"
              :key="dataKeyInfo.key"
              :label="dataKeyInfo.i18nName"
              :value="dataKeyInfo.key"
            ></el-option>
          </el-select>
        </template>
        <template #action-btn="{ row, $index }">
          <div :class="dragBtnClass">
            <i class="btn-icon iconfont iconMore"></i>
          </div>
          <el-button class="delete-btn" type="text" @click="onDeleteClick(row, $index)">{{ $t('common.btn.delete') }}</el-button>
        </template>
      </TableList>
      <div class="response-previewer">

      </div>
    </div>
    <div class="editor-foot">
      <el-button class="cancel-btn" @click="onCancel">{{ $t('common.btn.cancel') }}</el-button>
      <el-button class="save-btn" @click="onSave">{{ $t('common.btn.save') }}</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.openApi',
      dragBtnClass: 'drag-btn',
      vid: 0,
      loading: false,
      openApi: null,
      dataKeyInfoList: [],
      configInfoList: []
    }
  },
  computed: {
    openApiId () {
      return this.$route.params.openApiId
    },
    tableColumns () {
      const columns = [
        {
          labelI18nKey: `${this.i18nPrefix}.label.responseKey`,
          dataKey: 'responseKey',
          slotName: 'responseKey'
        },
        {
          labelI18nKey: `${this.i18nPrefix}.label.dataKey`,
          dataKey: 'dataKey',
          slotName: 'dataKey',
          width: '300px'
        }
      ]
      return columns
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('openApi', ['getOpenApiConfig', 'saveOpenApiConfig']),
    async initData () {
      this.loading = true
      try {
        const resp = await this.getOpenApiConfig({ openApiId: this.openApiId })
        if (resp) {
          this.openApi = resp.open_api
          this.dataKeyInfoList = _.map(resp.response.data_key_list, (dataKeyInfo) => addI18nProperty(dataKeyInfo, 'i18nName', 'cn_name', 'en_name'))
          this.vid = 0
          if (resp?.config?.response_config) {
            this.configInfoList = _.map(resp.config.response_config, (dataKey, responseKey) => {
              this.vid += 1
              return {
                _vid: this.vid,
                dataKey,
                responseKey
              }
            })
          } else {
            this.configInfoList = _.map(this.dataKeyInfoList, (dataKeyInfo) => {
              this.vid += 1
              return {
                _vid: this.vid,
                dataKey: dataKeyInfo.key,
                responseKey: dataKeyInfo.key
              }
            })
          }
          this.configInfoList.push({
            _vid: -1,
            isAddBtnLine: true
          })
        }
      } finally {
        this.loading = false
      }
    },
    spanMethod ({ row, columnIndex }) {
      if (!row.isAddBtnLine) {
        return
      }
      if (columnIndex === 0) {
        return {
          rowspan: 1,
          colspan: 3
        }
      } else {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    },
    onAddClick () {
      this.vid += 1
      const dataKeyInfo = this.dataKeyInfoList[0]
      this.configInfoList.splice(this.configInfoList.length - 1, 0, {
        _vid: this.vid,
        dataKey: dataKeyInfo.key,
        responseKey: dataKeyInfo.key
      })
    },
    onDeleteClick (row, index) {
      this.configInfoList.splice(index, 1)
    },
    onCancel () {
      this.$router.back()
    },
    async onSave () {
      if (this.loading) {
        return
      }

      this.loading = true
      try {
        const responseConfig = {}
        _.forEach(this.configInfoList, (configInfo) => {
          if (configInfo.isAddBtnLine) {
            return
          }
          responseConfig[configInfo.responseKey] = configInfo.dataKey
        })
        const resp = await this.saveOpenApiConfig({
          openApiId: this.openApi.id,
          config: {
            response_config: responseConfig
          }
        })
        if (resp) {
          this.$nextTick(() => this.$router.push('/v-admin/company-admin/open-api/list'))
          this.$message.success(this.$t('common.message.saveSuccess'))
        } else {
          this.$message.success(this.$t('common.message.saveFail'))
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.open-api-config-editor {
  .editor-body {
    // display: flex;
    .response-config {
      // width: 50%;
      .drag-btn {
        display: inline-block;
        vertical-align: middle;
        line-height: 1;
        margin-right: 10px;
        cursor: grab;
        .btn-icon {
          font-size: 26px;
        }
      }
      .delete-btn {
        vertical-align: middle;
      }
      .add-btn-wrapper {
        text-align: center;
        .add-btn {
          width: 200px;
          background: #b2b2b2;
          color: #fff;
          &:focus, &:hover {
            border-color: #dcdcdc;
          }
        }
      }
    }

    // .response-previewer {
    //   width: 50%;
    // }
  }
  .editor-foot {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;

    .el-button {
      padding: 8px 28px;
      border-radius: 2px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #0096cc;

      &.save-btn {
        margin-left: 24px;
        margin-right: 0;
        background: #0096cc;
        border-color: #0096cc;
        color: #ffffff;
      }
    }
  }
}
</style>
